import * as React from 'react';
import { NewsBondsElement } from '../../../element';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../../../../../../../sanity';

export const DesktopMapper = () => {
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  if (data == null) {
    return null;
  }
  return (
    <>
      {data.map((sAccId) => (
        <NewsBondsElement
          key={`${sAccId}`}
          sAccId={sAccId}
        />
      ))}
    </>
  );
};
